import { ResourceType } from "@/game/entities/config/resources";
import { UpgradeIds } from "@/game/entities/config/upgrades";
import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import useResourcesStore from "@/store/useResourcesStore";
import { SuperClickerEnum } from "@/store/useRuntimeStore";
import useShopStore from "@/store/useShopStore";
import type { ShopItem } from "@/types/shop";
import { ceilNumber } from "../number";
import { replacePlaceholder } from "../replacePlaceholder";

export const getReplaceValue = (key: string): number | null => {
	if (key === ResourceType.SUPER_CLICKER) {
		return (
			SuperClickerEnum.TEN +
			getUpgradeCurrentReplaceValueById(UpgradeIds.butterfingers)
		);
	}
	return null;
};

export const isMultiplier = (key: ResourceType): boolean => {
	return key.includes("Multiplier");
};

export const getMultiplierResourceType = (key: ResourceType): ResourceType => {
	return key.replace("Multiplier", "") as ResourceType;
};

export const multiplierValue = (key: ResourceType, value: number): number => {
	const resourcesStore = useResourcesStore();

	return ceilNumber(
		value *
			resourcesStore.getCurrencyValue(
				`${getMultiplierResourceType(key)}Income` as ResourceType,
			),
	);
};

export const multiplierMinValue = (value: number): number => {
	return value / 6; // 6 ticks per min
};

export const multiplierHeading = (key: string, value: number): string => {
	return replacePlaceholder(key, "{number}", multiplierMinValue(value));
};

export const provisionDaysInMs = (storeId: string): number => {
	const provisionOffers = useShopStore().provisionOffers;
	if (!provisionOffers) return 0;

	const offer = provisionOffers.find(
		(offer: ShopItem): boolean => offer.store_id === storeId,
	);
	const rewardDurationDays = offer?.attributes.reward_duration_days;

	return rewardDurationDays ? rewardDurationDays * 24 * 60 * 60 * 1_000 : 0;
};
